'use strict';

var LocalizationMixin = require('./LocalizationMixin');
var LocalizationManager = require('./LocalizationManager');
var localizedMixin = LocalizationMixin.functionVersion;

//create a LocalizationManager, pull in all localized data for the common-web components
var commonManager = new LocalizationManager();
commonManager.setDefault(require("./en_US"));
commonManager.set('en', 'US', require('./en_US'));
commonManager.set('en', 'CA', require('./en_CA'));
commonManager.set('fr', 'CA', require('./fr_CA'));
commonManager.set('es', 'US', require('./es_US'));

/**
 * This creates a mixin to use for any components living in the common-web project. Other
 * projects should create a local mixin like this to manage its own locale data.
 * @type {LocalizationMixin}
 */
module.exports = new LocalizationMixin(commonManager);
module.exports.functionVersion = new localizedMixin(commonManager);


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/localization/CommonLocalizationMixin.js
// module id = 13
// module chunks = 0